module.exports = __webpack_public_path__ + "media/images/link-85a34099.svg";